export enum ProductCategories {
  TYPICAL = "TYPICAL",
  FEATURED = "FEATURED",
}
